export const locale = {
  lang: "en-CA",
  data: {
    PHOTO_LIBRARY_PANEL: {
      TITLE: "Select an image from the library",
      TAB_MINE: "My library",
      TAB_GT: "GT library",
      SEARCH: "Search",
      EMPTY: "No image found.",
      ADD: "Add",
    },
  },
};
